// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__cjD+d","spin":"Spinner_spin__uyAtH"};